<template>
  <div class="modal" @click.self="onBackdrop">
    <div class="modal-content">
      <h3>Практическая часть обучения</h3>

      <template v-if="done">
        <p>Лист практики принят. Вы можете приступить к экзамену.</p>

        <button type="button" class="btn btn-secondary btn-modal" @click="$emit('passed')">
          Перейти к экзамену
        </button>
        <button type="button" class="btn btn-secondary btn-modal" @click="$emit('close')">Закрыть</button>
      </template>

      <template v-else-if="pepAllowed">
        <p>Уважаемый слушатель, Вы успешно завершили обучение.</p>
        <p>
          Пожалуйста, подпишите простой электронной подписью
          <a v-if="sheetUrl" :href="sheetUrl" target="_blank" class="sheet-link">«Лист практики»</a><template v-else>«Лист практики»</template>.
        </p>
        <p class="hint">Если не подпишете сейчас, лист практики останется доступен в разделе «Практика».</p>

        <button type="button" class="btn btn-secondary btn-modal" :disabled="busy" @click="sign">
          {{ busy ? 'Подписываем…' : 'Подписать' }}
        </button>
        <button type="button" class="btn btn-outline btn-modal" :disabled="busy" @click="$emit('close')">Позже</button>

        <p v-if="error" class="error">{{ error }}</p>
      </template>

      <template v-else>
        <p>Уважаемый слушатель, Вы успешно завершили обучение.</p>
        <p>
          Скачайте
          <a v-if="sheetUrl" :href="sheetUrl" target="_blank" class="sheet-link">«Лист практики»</a><template v-else>«Лист практики»</template>,
          подпишите его и загрузите скан или фотографию
          подписанного листа — после этого откроется доступ к экзамену.
        </p>
        <p class="hint">Если не загрузите сейчас, это можно сделать позже в разделе «Практика».</p>

        <div class="upload">
          <input ref="file" type="file" class="practice-file-input" accept=".pdf,.jpg,.jpeg,.png,.heic,.tif,.tiff,.bmp" @change="error = ''">
        </div>

        <button type="button" class="btn btn-secondary btn-modal" :disabled="busy" @click="upload">
          {{ busy ? 'Загружаем…' : 'Отправить' }}
        </button>
        <button type="button" class="btn btn-outline btn-modal" @click="$emit('close')">Позже</button>

        <p v-if="error" class="error">{{ error }}</p>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    sheetUrl: {
      type: String,
      default: ''
    },
    signUrl: {
      type: String,
      default: ''
    },
    uploadUrl: {
      type: String,
      default: ''
    },
    pepAllowed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      busy: false,
      done: false,
      error: ''
    };
  },
  methods: {
    // Пока идёт запрос, случайный клик мимо окна не должен его закрывать
    onBackdrop() {
      if (!this.busy) {
        this.$emit('close');
      }
    },
    sign() {
      if (this.busy) return;

      this.busy = true;
      this.error = '';

      axios
        .post(this.signUrl)
        .then(() => {
          this.done = true;
        })
        .catch((e) => {
          this.error = (e.response && e.response.data && e.response.data.message) || 'Не удалось подписать лист практики';
        })
        .then(() => {
          this.busy = false;
        });
    },
    upload() {
      if (this.busy) return;

      const input = this.$refs.file;
      const file = input && input.files && input.files[0];

      if (!file) {
        this.error = 'Выберите файл с подписанным листом практики';
        return;
      }

      const data = new FormData();
      data.append('sheet', file);

      this.busy = true;
      this.error = '';

      axios
        .post(this.uploadUrl, data)
        .then(() => {
          this.done = true;
        })
        .catch((e) => {
          this.error = (e.response && e.response.data && e.response.data.message) || 'Не удалось загрузить лист практики';
        })
        .then(() => {
          this.busy = false;
        });
    }
  }
};
</script>

<style scoped>
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}

.modal-content {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  width: 90%;
  max-width: 640px;
  max-height: 90vh;
  overflow-y: auto;
  text-align: left;
}

.modal-content h3 {
  margin-bottom: 1rem;
}

.modal-content p {
  margin-bottom: 0.75rem;
}

.upload {
  margin: 12px 0;
}

.hint {
  font-size: 0.9em;
  color: #76838f;
}

.sheet-link {
  color: rgb(248, 108, 1);
  text-decoration: underline;
}

.error {
  color: #d9534f;
  margin-top: 10px;
}

.btn {
  padding: 5px 10px;
  cursor: pointer;
  border: none;
  border-radius: 4px;
}

.btn:disabled {
  opacity: 0.6;
  cursor: default;
}

.btn-secondary {
  background-color: rgb(248, 108, 1);
  color: white;
}

.btn-outline {
  background-color: transparent;
  color: rgb(248, 108, 1);
  border: 1px solid rgb(248, 108, 1);
}

a.btn {
  display: inline-block;
  text-decoration: none;
}

.btn-modal {
  margin-top: 5px;
  margin-right: 5px;
}
</style>
